import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation, useParams } from 'react-router-dom';
import playIcon from '../../res/images/play_arrow.png'
import Back from '../../res/images/back-icon.svg'
import AFN_Logo from '../../res/images/afn-go-logo.svg'
import AFNGo from '../../res/images/afn-go-logo.svg'
import axios from 'axios';
import { useAuth, useTrack } from '../common/context';
import PauseIcon from '../../res/images/pause-icon.svg';
import { player } from '../common/player';
import moment from 'moment';

const Omny = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { program } = location.state;
    const [trackList, setTrackList] = useState([])
    const {onSetSelectedTrack, onSetPlayerState, selectedTrack, playerState} = useTrack()
    const {onRadioChange, onSetTrackDetails } = useAuth()

    useEffect(() => {
        axios.get(`https://omny.fm/api/orgs/58771630-df14-4cd9-95b0-ade300f713f0/programs/${program?.Id}/clips`)
        .then((res) => {
            // console.log('res.data: ',res?.data?.Clips)
            setTrackList([...(res?.data?.Clips || [])].sort((a, b) => moment(b?.ModifiedAtUtc).diff(moment(a?.ModifiedAtUtc))))
        })
        .catch((err) => {
            console.log(err)
        })
        
    }, [program])

    const onPlayPauseTrack = (item) => {
        /// Reset Radio player ///
        player.stop();
        onSetTrackDetails({});
        onRadioChange({item: null,playState:false})
        /// Reset Radio player ///

        if(selectedTrack?.id == item?.Id && playerState == "PLAY"){
            onSetPlayerState('STOP')
        }else{
            onSetSelectedTrack({
                id: item?.Id,
                thumbnail: item?.ImageUrl,
                title: program?.Name,
                description: item?.Title,
                file: item?.AudioUrl,
            })
            onSetPlayerState('PLAY')
        }
    }

    return (
        <>
            <div>
                <div className="sidebar-overlay"></div>
                {/* <SideBar /> */}
                <section className="afn-page-body afn-full-page-body list-body">
                    <div className="container-fluid">
                        <Link className='radio-header-logo' to='/'>
                            <img src={AFN_Logo} alt="minimize" class="img-fluid" />
                        </Link>

                        <>
                            <img onClick={() => navigate(-1)} src={Back} alt="minimize" class="img-fluid minimize mobile-none" />

                            <div className='desktop-none header-mobile-menu'>
                                <img onClick={() => navigate(-1)} src={Back} alt="minimize" class="img-fluid minimize " />
                                {/* <img src={SearchIcon} alt="minimize" class="img-fluid minimize " /> */}
                                <div className="page-head">
                                </div>
                            </div>
                            
                            <h3 class="list-title mobile-none stationHeadingText">Podcast</h3>

                            <div className='radio-list-wrapper desktop-none'>
                                <h3 class="list-title stationHeadingText">Podcast</h3>
                                {trackList?.length > 0 ?
                                    <>
                                        {trackList?.map((item, index) => {
                                            return (
                                                <div className='radio-detail-box'>
                                                    <div className='station-imgBox' style={{flex: 0.15, maxHeight: 60, maxWidth: 60}}>
                                                        <img src={item?.ImageUrl || AFNGo} alt="minimize" class="img-fluid afn-thumbnail" />
                                                    </div>
                                                    <div className='radio-detail-contentBox' style={{flex: 0.8}}>
                                                        <h3 style={{overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 1,  /* number of lines to show */   lineClamp: 2,  WebkitBoxOrient: 'vertical',}}>{item?.Title} </h3>
                                                        <p style={{overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 1,  /* number of lines to show */   lineClamp: 2,  WebkitBoxOrient: 'vertical',}}>{item?.ModifiedAtUtc && `${moment(item?.ModifiedAtUtc).format('DD/MM/YY')} - `}{`${item?.Description?.replace(/\n/g, '. ')}`}</p>
                                                    </div>
                                                    <img src={ (selectedTrack?.id == item?.Id && playerState == "PLAY") ? PauseIcon : playIcon} alt=""  style={{flex: 0.05}} className='hoverAbleCol' onClick={()=> onPlayPauseTrack(item)}/>
                                                </div>
                                            )
                                        })}
                                    </>
                                    :
                                    <span className='NotFountText'>Episode Not Found</span>
                                }
                                
                            </div>
                            <div className='row radio-list-row mobile-none'>
                                {trackList?.length > 0 ?
                                    <>
                                        <div className='col-lg-7 mobile-none'>
                                            <div className="listBox-header">
                                                <div className='row'>
                                                    <div className='col-lg-2 col-md-2'>

                                                    </div>
                                                    <div className='col-lg-2 col-md-2'>
                                                        <div class="list-left-textBox">
                                                            Episode
                                                        </div>
                                                    </div>
                                                    <div className='col-lg-7 col-md-7'>
                                                        <div class="list-middle-textBox">
                                                            Description
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div className='clearfix'></div>

                                        {trackList?.map((item, index) => (
                                            <>
                                                <div className='col-lg-7' key={index}>
                                                    <div className="listBox-card">
                                                        <div className='row align-items-center'>
                                                            <div className='col-lg-2 col-md-2'>
                                                                <div className='stationImg'>
                                                                    <img src={item?.ImageUrl || AFNGo} alt="minimize" class="img-fluid afn-thumbnail" />
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-2 col-md-2'>
                                                                <div style={{overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2,  /* number of lines to show */   lineClamp: 2,  WebkitBoxOrient: 'vertical',}} class="list-left-textBox">
                                                                    {item?.Title}
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-7 col-md-7'>
                                                                <div style={{overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2,  /* number of lines to show */   lineClamp: 2,  WebkitBoxOrient: 'vertical',}} class="list-middle-textBox">
                                                                    {item?.ModifiedAtUtc && `${moment(item?.ModifiedAtUtc).format('DD/MM/YY')} - `}{`${item?.Description?.replace(/\n/g, '. ')}`}
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-1 col-md-1'>
                                                                <div class="list-right-textBox">
                                                                    {/* <img src={playIcon} alt="" className='hoverAbleCol' onClick={()=> onPlayPauseTrack(item)}/> */}
                                                                    <img src={ (selectedTrack?.id == item?.Id && playerState == "PLAY") ? PauseIcon : playIcon} alt=""  style={{flex: 0.05}} className='hoverAbleCol' onClick={()=> onPlayPauseTrack(item)}/>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className='clearfix'></div>
                                            </>
                                        ))}
                                    </>
                                    :
                                    <span className='NotFountText'>Episode Not Found</span>
                                }
                            </div>
                        </>

                    </div>
                </section>
            </div>
        </>
    );
}

export default Omny;